import { SystemUserReportsService } from '../../services/systemUserReports.service';

import { SystemUserReportsStore } from '../../stores/systemUserReports.store';

export default async function loadSystemUseReports(filters) {
  const data = await SystemUserReportsService.load(filters);
  SystemUserReportsStore.reports.set(data);
}
